import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as profileReducers from '@feature/profiles/reducers/profiles';
import * as supplierOtherCreditorReducers from '@feature/suppliers/reducers/supplier-other-creditor.reducers';
import * as profileSelectors from '@feature/profiles/selectors/profiles';
import { Profile } from '@feature/profiles/models/profile';
import { SupplierOtherCreditorProfile } from '@admin/supplier-other-creditor/models/supplier-other-creditor-profile';
import * as ProfileTypes from '@feature/profiles/models/profile-types';
import { SupplierOtherCreditorTypes } from '@feature/suppliers/models/supplier-other-creditor-types';

export const selectProfileState = createFeatureSelector<profileReducers.State>('profiles');
export const selectSupplierOtherCreditorState = createFeatureSelector<supplierOtherCreditorReducers.State>('supplierOtherCreditors');

export const selectLoading = createSelector(
  [selectSupplierOtherCreditorState],
  (supplierState: supplierOtherCreditorReducers.State) => {
    return supplierState.loading;
  }
);

export const selectClientProfiles = createSelector(
    [selectSupplierOtherCreditorState, profileSelectors.selectAll],
    (supplierState: supplierOtherCreditorReducers.State, allProfiles: Profile[]) => {
        var supplierOtherCreditorProfiles: SupplierOtherCreditorProfile[] = [];
        if (supplierState.supplierOtherCreditors != undefined) {
          var supplierOtherCreditors = supplierState.supplierOtherCreditors;
          for (let supplierOtherCreditor of supplierOtherCreditors) {
            var newSupplierCreditorProfile: SupplierOtherCreditorProfile = new SupplierOtherCreditorProfile();
            newSupplierCreditorProfile.ref = supplierOtherCreditor.Ref;
              newSupplierCreditorProfile.name = supplierOtherCreditor.Name;
              newSupplierCreditorProfile.type = supplierOtherCreditor.Type;

            var foundProfile = supplierOtherCreditor.Type == SupplierOtherCreditorTypes.Supplier
                ? getProfileForSupplier(allProfiles, supplierOtherCreditor.Ref)
                : getProfileForOtherCreditor(allProfiles, supplierOtherCreditor.Ref);
            if (foundProfile != null) {
              newSupplierCreditorProfile.profile = foundProfile;
            }

            supplierOtherCreditorProfiles.push(newSupplierCreditorProfile);
          }
        }
        return supplierOtherCreditorProfiles;
  }
);


function getProfileForSupplier(profiles: Profile[], ref: number): Profile {
  for (let profile of profiles) {
    if (profile.supplierRefs != undefined) {
        if (profile.supplierRefs.includes(ref)) {
        return profile;
      }
    }
  }
  return profiles.find(x => x.type === ProfileTypes.Standard);
}

function getProfileForOtherCreditor(profiles: Profile[], ref: number): Profile {
  for (let profile of profiles) {
    if (profile.creditorRefs != undefined) {
        if (profile.creditorRefs.includes(ref)) {
        return profile;
      }
    }
  }
  return profiles.find(x => x.type === ProfileTypes.Standard);
}
